var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-switch',{staticClass:"mb-2",attrs:{"label":"appendIcon","dense":"","hide-details":""},on:{"change":_vm.toggleAppendIcon},model:{value:(_vm.enabled),callback:function ($$v) {_vm.enabled=$$v},expression:"enabled"}}),(_vm.enabled)?_c('DevContainerOfPanel',{attrs:{"schema":{
      type: 'devContainerOfPanel',
      model: 'appendIcon',
      component: 'dev-simple-object-attr',
      styleClasses: 'col-12',
      title: 'append Icon'
    },"model":{ appendIcon: _vm.model.appendIcon }}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }